import { render, staticRenderFns } from "./ClientStatusTable.vue?vue&type=template&id=382eb107&scoped=true&"
import script from "./ClientStatusTable.vue?vue&type=script&lang=js&"
export * from "./ClientStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientStatusTable.vue?vue&type=style&index=0&id=382eb107&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382eb107",
  null
  
)

export default component.exports